import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { SvgIcon } from '../svg-icon'

import styles from './close-icon.module.css'

const propTypes = {
    className: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Renders a close icon that looks like 'X'
 * @see SvgIcon for propTypes
 *
 * @example
 * <CloseIcon width={12} />
 */
const CloseIcon = props => (
    <SvgIcon {...props} className={cx(styles['close-icon'], props.className, 't3sel-close-icon')}>
        <path
            d={`M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17
            11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z`}
        />
        <path d="M0 0h48v48h-48z" fill="none" />
    </SvgIcon>
)

CloseIcon.defaultProps = defaultProps
CloseIcon.propTypes = propTypes

export { CloseIcon }
